// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"499":"954b09ee","596":"8661c94a","942":"c3d2345c"}[chunkId] + ".css";
};